/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Link } from "react-router-dom";

import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";

import * as auth from "../redux/AuthRedux";
import { useDispatch } from "react-redux";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { toAbsoluteUrl } from "../../../../_jutemplate/helpers/AssetHelpers";
import "./auth.css";
import { login } from "../redux/AuthCRUD";

//image

const initialValues = {
  phone: "",
  password: "",
};

const loginSchema = Yup.object().shape({
  phone: Yup.string().required("Phone number is required"),
  password: Yup.string()
    .min(3, "Password should be minimum 3 character")
    .max(50, " Password should be maximum 20 character")
    .required("Password is required"),
});

export function Login() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setTimeout(() => {
        login(values.phone, values.password)
          .then(
            (res) => {
              setLoading(false);
              //let roleID = res?.data?.data?.role?.role_id

              if (res?.data?.data) {
                let token = res?.data?.data?.token;
                // console.log(token)
                // dispatch user
                dispatch(auth.actions.login(token));
              } else {
                // console.log('adadad')
                toast(res.data.message, {
                  theme: "dark",
                });
              }
              //setStatus(res.data.message)

              //0setSubmitting(false)
            },
            (err:any) => {
              setStatus(err.message);
              if (err.response.data.success === false) {
                toast.error(err.response.data.message, {
                  theme: "dark",
                });
                setStatus(err.response.data.message);
              } else {
                toast.error("Service Unavailable", {
                  theme: "dark",
                });
              }
              console.log(err)
              setSubmitting(false);
              setLoading(false);
            }
          )
          .catch((err:any) => {
            toast.error("Something Went Wrong", {
               theme: "dark",
            });
            setLoading(false);
            setSubmitting(false);
            setStatus("The login detail is incorrect");
          });
      }, 1000);
    },
  });

  return (
    <>
      {/* alert */}
      <ToastContainer />

      {/* form */}
      <form
        className="form w-100"
        onSubmit={formik.handleSubmit}
        noValidate
        id="kt_login_signin_form"
      >
        {/* begin :: Heading */}
        <div className="d-flex flex-column align-items-center ">
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/logos/logo-hanay.svg")}
            // className="h-45px"
            style={{ height: "180px" }}
          />
          <h2
            className="fw-semibold m-0 mb-2"
            style={{ color: "#2F3367", fontSize: "18px" }}
          >
            Welcome
          </h2>
          <h5
            className="fw-normal m-0"
            style={{ color: "#303468", fontSize: "18px" }}
          >
            Please! Provide Your Phone & Password
          </h5>
        </div>

        {/* begin::Heading */}

        {/* begin::Form group */}
        <div className="fv-row mt-10">
          {/* <label className="form-label fs-6 fw-bolder text-dark">Phone Number</label> */}
          <input
            placeholder="Phone Number"
            {...formik.getFieldProps("phone")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2",
              { "is-invalid": formik.touched.phone && formik.errors.phone },
              {
                "is-valid": formik.touched.phone && !formik.errors.phone,
              }
            )}
            type="text"
            name="phone"
            autoComplete="off"
          />
          {formik.touched.phone && formik.errors.phone && (
            <div className="fv-plugins-message-container">
              <span role="alert" className="error text-danger">
                {formik.errors.phone}
              </span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className="fv-row mt-6">
          <input
            type="password"
            placeholder="Password"
            autoComplete="off"
            {...formik.getFieldProps("password")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2",
              {
                "is-invalid": formik.touched.password && formik.errors.password,
              },
              {
                "is-valid": formik.touched.password && !formik.errors.password,
              }
            )}
          />
          {formik.touched.password && formik.errors.password && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span role="alert" className="error text-danger">
                  {formik.errors.password}
                </span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Action */}

        <button
          type="submit"
          id="kt_sign_in_submit"
          className="loginbtn w-100 mt-10"
          // disabled={formik.isSubmitting || !formik.isValid}
          disabled={loading ? true : false}
        >
          {!loading && <span className="indicator-label">Login</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>

        <div className="d-flex justify-content-end mt-5">
          <Link
            to="forgot-password"
            className="ps-3 forgotpassword-link"
           >
            Forgot passwords?
          </Link>
        </div>
        {/* end::Action */}
      </form>
    </>
  );
}
